import logo from './logo.svg';
import './App.css';
import AllpageRout from './Router/AllpageRout';

import BookingPage from './Pages/BookingPage';
function App() {
  
  
  return (

    <div className="App">
     {/* <BasicModal /> */}
      <AllpageRout/>
      
       {/* <BookingPage /> */}
    </div>
  );
}

export default App;
